/**
 * Ce que la fiche client dit de l'envoi d'un dossier à chaque agrégateur.
 *
 * Fonctions pures, testées dans `envois-etat.test.js` : l'écran ne fait qu'afficher ce
 * qu'elles décident. `ton` pilote la couleur, `texte` est la phrase à lire, et l'action
 * proposée ne dépend que de l'état reçu du serveur (`GET .../clients/{id}/envois`).
 *
 * L'ordre des cas suit l'ordre où ils se réparent : ce qui bloque d'abord (un geste à
 * faire ailleurs), puis la dernière erreur, puis l'état normal. Une erreur affichée
 * sous un « tout va bien » serait lue en dernier, donc jamais.
 */

const nb = (n, mot) => `${n} ${mot}${n > 1 ? 's' : ''}`;

export function etatSymphonics(etat = {}) {
  const declares = etat.actifs_declares || [];
  if (declares.length === 0) {
    return { ton: 'bloque', peutEnvoyer: false,
             texte: 'Aucun actif déclaré à Symphonics. Déclarer au moins un équipement ci-dessus.' };
  }
  if (etat.statut === 'failed') {
    return { ton: 'erreur', peutEnvoyer: true,
             texte: `Dernier envoi refusé : ${etat.erreur || 'raison non rendue'}` };
  }
  if (etat.statut === 'synced') {
    return { ton: 'ok', peutEnvoyer: true,
             texte: `Dossier envoyé (référence Symphonics ${etat.lead_id || 'non rendue'}).` };
  }
  if (etat.statut === 'dry_run') {
    return { ton: 'attente', peutEnvoyer: true,
             texte: `Aperçu vérifié, dossier jamais envoyé. ${nb(declares.length, 'actif')} partirai${declares.length > 1 ? 'ent' : 't'}.` };
  }
  return { ton: 'attente', peutEnvoyer: true,
           texte: `Jamais envoyé. ${nb(declares.length, 'actif')} déclaré${declares.length > 1 ? 's' : ''}.` };
}

export function etatSurvoltage(etat = {}) {
  const declares = etat.actifs_declares || [];
  if (etat.configure === false) {
    return { ton: 'bloque', action: null,
             texte: `Canal Survoltage non configuré : ${(etat.manques || []).join(', ')}.` };
  }
  if (etat.erreur) {
    return { ton: 'erreur', action: etat.raccorde ? 'renvoyer' : 'raccorder',
             texte: `Dernier envoi refusé : ${etat.erreur}` };
  }
  if (!etat.raccorde) {
    if (declares.length === 0) {
      return { ton: 'bloque', action: null,
               texte: 'Aucun actif déclaré à Survoltage. Déclarer au moins un équipement ci-dessus.' };
    }
    return { ton: 'attente', action: 'raccorder',
             texte: `Client pas encore créé chez Survoltage. ${nb(declares.length, 'actif')} à envoyer.` };
  }
  const envoyes = etat.actifs_envoyes || [];
  const aJour = envoyes.length === declares.length && declares.every((r) => envoyes.includes(r));
  if (!aJour) {
    return { ton: 'attente', action: 'renvoyer',
             texte: 'La liste connue de Survoltage n\'est pas à jour avec nos déclarations.' };
  }
  return { ton: 'ok', action: 'renvoyer',
           texte: `Raccordé : ${nb(envoyes.length, 'actif')} connu${envoyes.length > 1 ? 's' : ''} de Survoltage.` };
}
